import { sessionGetJSONItem, sessionSetJSONItem, } from "../services/SessionStorage";
const initialDineInLocationKey = "initialDineInLocation";
export function getQrWaiterParameters() {
    const searchParams = new URLSearchParams(window.location.search);
    const tableParam = searchParams.get("table");
    const areaIdParam = searchParams.get("areaId");
    const pointName = searchParams.get("pointName");
    if (tableParam != null) {
        const number = parseInt(tableParam);
        if (!isNaN(number)) {
            return { table: number };
        }
    }
    if (areaIdParam !== null && pointName != null) {
        const areaId = parseInt(areaIdParam);
        if (!isNaN(areaId)) {
            return { areaId, pointName };
        }
    }
    return null;
}
export function isQrWaiterOrder() {
    return (getQrWaiterParameters() !== null || getSessionDineInLocation() !== null);
}
export function getSessionDineInLocation() {
    return sessionGetJSONItem(initialDineInLocationKey);
}
export function setDineInLocation(location) {
    sessionSetJSONItem(initialDineInLocationKey, location);
}
